import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

export default function AutomationPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [toggling, setToggling] = useState(false);
  const [settings, setSettings] = useState({ engine_target_pipeline: 50, engine_max_daily_leads: 200, engine_location: '', engine_industry: '' });
  const [settingsSaved, setSettingsSaved] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    if (user && user.plan !== 'Pro+') return;
    const load = () => api.getEngineStatus().then(s => { setStatus(s); setSettings(prev => ({ ...prev, engine_target_pipeline: s.target_pipeline || 50, engine_max_daily_leads: s.max_daily_leads || 200 })); }).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    const p = setInterval(() => setPulse(x => !x), 800);
    return () => { clearInterval(t); clearInterval(p); };
  }, [user?.plan]);

  if (user && user.plan !== 'Pro+') {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "calc(100vh - 140px)", gap: 20, textAlign: "center" }}>
        <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#534AB7,#1D9E75)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <i className="ti ti-sparkles" style={{ fontSize: 28, color: "#fff" }} aria-hidden="true" />
        </div>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "var(--text)", marginBottom: 8 }}>24/7 Mode</div>
          <div style={{ fontSize: 13, color: "var(--text2)", maxWidth: 400, lineHeight: 1.7, marginBottom: 6 }}>FLO runs continuously — scraping leads, texting them, and booking appointments. Zero manual work required.</div>
          <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 24 }}>Available on the <strong style={{ color: "var(--text)" }}>Agency plan</strong></div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, maxWidth: 480, margin: "0 auto 24px" }}>
            {[{ icon: "ti-refresh", label: "Scrapes 24/7", desc: "Finds leads continuously" }, { icon: "ti-message-bolt", label: "Auto-texts", desc: "Contacts every new lead" }, { icon: "ti-calendar-check", label: "Books appointments", desc: "AI closes while you sleep" }].map(f => (
              <div key={f.label} style={{ padding: "14px 12px", borderRadius: 12, border: "0.5px solid rgba(83,74,183,0.2)", background: "var(--bg2)", textAlign: "center" }}>
                <i className={"ti " + f.icon} style={{ fontSize: 22, color: "#534AB7", marginBottom: 8, display: "block" }} aria-hidden="true" />
                <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text)", marginBottom: 3 }}>{f.label}</div>
                <div style={{ fontSize: 11, color: "var(--text2)" }}>{f.desc}</div>
              </div>
            ))}
          </div>
          <button onClick={() => navigate('/dashboard/settings')} style={{ padding: "11px 32px", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#534AB7,#1D9E75)", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", boxShadow: "0 4px 16px rgba(83,74,183,0.35)" }}>
            Upgrade to Agency — $497/mo
          </button>
        </div>
      </div>
    );
  }

  const handleToggle = async () => {
    setToggling(true);
    try {
      if (status && status.running) await api.stopEngine();
      else await api.startEngine();
      const updated = await api.getEngineStatus();
      setStatus(updated);
    } catch (err) { alert(err.message); }
    setToggling(false);
  };

  const handleSaveSettings = async () => {
    try { await api.saveEngineSettings(settings); setSettingsSaved(true); setTimeout(() => setSettingsSaved(false), 2000); }
    catch (err) { alert(err.message); }
  };

  const isRunning = status && status.running;
  const card = { background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(83,74,183,0.3)", overflow: "hidden", boxShadow: "0 0 30px rgba(83,74,183,0.08)" };
  const hdr = { padding: "14px 20px", borderBottom: "0.5px solid var(--border)", background: "linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))", display: "flex", alignItems: "center", gap: 10 };
  const dot = (color) => ({ width: 8, height: 8, borderRadius: "50%", background: color, boxShadow: `0 0 8px ${color}` });
  const lbl = { fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 5, textTransform: "uppercase", letterSpacing: "0.5px" };
  const inp = { width: "100%", padding: "9px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", boxSizing: "border-box" };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 720 }}>

      {/* Engine control */}
      <div style={card}>
        <div style={hdr}>
          <div style={dot(isRunning ? "#1D9E75" : "#534AB7")} />
          <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>24/7 Autonomous Engine</span>
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
            {isRunning && (
              <div style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: "rgba(29,158,117,0.1)", border: "0.5px solid rgba(29,158,117,0.3)" }}>
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: pulse ? "#1D9E75" : "#5DCAA5", transition: "background 0.4s" }} />
                <span style={{ fontSize: 11, fontWeight: 600, color: "#1D9E75" }}>Running</span>
              </div>
            )}
            <button onClick={handleToggle} disabled={toggling} style={{ padding: "8px 20px", borderRadius: 8, border: "none", background: isRunning ? "rgba(224,92,92,0.1)" : "linear-gradient(135deg,#534AB7,#1D9E75)", color: isRunning ? "#E05C5C" : "#fff", fontSize: 12, fontWeight: 700, cursor: toggling ? "not-allowed" : "pointer", border: isRunning ? "0.5px solid rgba(224,92,92,0.3)" : "none", boxShadow: isRunning ? "none" : "0 2px 8px rgba(83,74,183,0.3)" }}>
              {toggling ? "..." : isRunning ? "Stop engine" : "Start engine"}
            </button>
          </div>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{ fontSize: 12, color: "var(--text2)", lineHeight: 1.6, marginBottom: 16 }}>Continuously scrapes leads, texts them, and books appointments — all while you sleep.</div>

          {/* Pipeline stats */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: 10, marginBottom: 14 }}>
            {[
              { label: "New", value: status?.pipeline?.new ?? "—", color: "#534AB7" },
              { label: "Contacted", value: status?.pipeline?.contacted ?? "—", color: "#378ADD" },
              { label: "Interested", value: status?.pipeline?.interested ?? "—", color: "#C4952A" },
              { label: "Booked", value: status?.pipeline?.booked ?? "—", color: "#1D9E75" },
              { label: "Trashed", value: status?.pipeline?.trashed ?? "—", color: "#E05C5C" },
            ].map(s => (
              <div key={s.label} style={{ textAlign: "center", padding: "12px 6px", background: "var(--bg3)", borderRadius: 10, border: "0.5px solid var(--border)" }}>
                <div style={{ fontSize: 22, fontWeight: 700, color: s.color }}>{s.value}</div>
                <div style={{ fontSize: 10, color: "var(--text2)", marginTop: 3, textTransform: "uppercase", letterSpacing: "0.4px" }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Today stats */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
            {[
              { label: "Leads scraped today", value: `${status?.today_leads || 0} / ${status?.max_daily_leads || 200}`, color: "#534AB7" },
              { label: "Texts sent today", value: status?.today_texts || 0, color: "#378ADD" },
              { label: "Appointments today", value: status?.today_booked || 0, color: "#1D9E75" },
            ].map(s => (
              <div key={s.label} style={{ padding: "12px 16px", background: "var(--bg3)", borderRadius: 10, border: "0.5px solid var(--border)" }}>
                <div style={{ fontSize: 11, color: "var(--text2)", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.4px" }}>{s.label}</div>
                <div style={{ fontSize: 20, fontWeight: 700, color: s.color }}>{s.value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Engine settings */}
      <div style={card}>
        <div style={hdr}>
          <div style={dot("#534AB7")} />
          <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Engine Settings</span>
        </div>
        <div style={{ padding: 20, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
          <div>
            <div style={lbl}>Target location</div>
            <input value={settings.engine_location} onChange={e => setSettings(s => ({ ...s, engine_location: e.target.value }))} placeholder="Tampa, FL" style={inp} />
          </div>
          <div>
            <div style={lbl}>Industry (blank = auto)</div>
            <input value={settings.engine_industry} onChange={e => setSettings(s => ({ ...s, engine_industry: e.target.value }))} placeholder="Leave blank for smart targeting" style={inp} />
          </div>
          <div>
            <div style={lbl}>Target pipeline size</div>
            <select value={settings.engine_target_pipeline} onChange={e => setSettings(s => ({ ...s, engine_target_pipeline: parseInt(e.target.value) }))} style={{ ...inp, cursor: "pointer" }}>
              {[25, 50, 100, 200, 500].map(v => <option key={v} value={v}>{v} uncontacted leads</option>)}
            </select>
          </div>
          <div>
            <div style={lbl}>Max leads per day</div>
            <select value={settings.engine_max_daily_leads} onChange={e => setSettings(s => ({ ...s, engine_max_daily_leads: parseInt(e.target.value) }))} style={{ ...inp, cursor: "pointer" }}>
              {[50, 100, 200, 500, 1000, 2500, 5000, 99999].map(v => <option key={v} value={v}>{v === 99999 ? 'Unlimited' : v + ' leads/day'}</option>)}
            </select>
          </div>
          <div style={{ gridColumn: "1/-1", display: "flex", gap: 10, alignItems: "center" }}>
            <button onClick={handleSaveSettings} style={{ padding: "10px 28px", borderRadius: 8, border: "none", background: "linear-gradient(135deg,#534AB7,#1D9E75)", color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", boxShadow: "0 2px 8px rgba(83,74,183,0.3)" }}>Save settings</button>
            {settingsSaved && <span style={{ fontSize: 12, color: "#1D9E75" }}>✓ Saved</span>}
          </div>
        </div>
      </div>

      {/* Live activity log */}
      <div style={card}>
        <div style={hdr}>
          <div style={dot("#1D9E75")} />
          <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Live Activity Log</span>
        </div>
        <div style={{ padding: "10px 0", maxHeight: 280, overflow: "auto" }}>
          {(!status?.log || status.log.length === 0) && (
            <div style={{ textAlign: "center", color: "var(--text3)", fontSize: 12, padding: "30px 0" }}>No activity yet — start the engine to begin</div>
          )}
          {status?.log?.map((entry, i) => (
            <div key={i} style={{ display: "flex", gap: 12, padding: "8px 20px", borderBottom: "0.5px solid var(--border)", fontSize: 12 }}
              onMouseEnter={e => e.currentTarget.style.background = "var(--bg3)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
              <span style={{ color: "var(--text3)", flexShrink: 0, fontFamily: "monospace", fontSize: 11 }}>{entry.time}</span>
              <span style={{ color: "var(--text)" }}>{entry.message}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}





